export default "<div [hidden]=\"hidden\" [ngClass]=\"{'flex-grow-1': !hidden}\">\r\n    <ng-template #container>\r\n    </ng-template>\r\n</div>\r\n"